import React from "react";
import { ArrowData } from "../contexts/DataContext";
import RouteColorSwatch from "../../Maps/ActiveRoutes/RouteColorSwatch";
import { normalizeSiteMapColor } from "../utils/colors";
import { useData } from "../contexts/DataContext";
import MapRouteSidebar from "../components/MapRouteSidebar";

// this route only is shown / operates in editing mode
const SiteMapArrowRoute = ({ arrow }: { arrow: ArrowData | undefined }) => {
  return <>{!arrow ? <NoArrowFound /> : <EditArrowDetails arrow={arrow} />}</>;
};

export default SiteMapArrowRoute;

const ArrowWrapper = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title: string;
}) => {
  return <MapRouteSidebar title={title}>{children}</MapRouteSidebar>;
};

const NoArrowFound = () => {
  return (
    <ArrowWrapper title="No Arrow">
      <div style={{ color: "red" }}>No arrow selected</div>
    </ArrowWrapper>
  );
};

const EditArrowDetails = ({ arrow }: { arrow: ArrowData }): JSX.Element => {
  const { deleteArrow, updateArrow } = useData();

  const handleArrowColorChange = (color: string) => {
    updateArrow({ ...arrow, color });
  };

  return (
    <>
      <ArrowWrapper title="Edit Arrow">
        <div>
          <label
            htmlFor="color"
            style={{ display: "block", marginBottom: "5px" }}
          >
            Color:
          </label>
          <RouteColorSwatch
            size="lg"
            placement="left"
            color={normalizeSiteMapColor(arrow.color, "red")}
            onChange={handleArrowColorChange}
            testId="arrow-color-swatch"
          />
          <button
            className="border border-gray-200 p-1 rounded hover:bg-gray-200"
            style={{ marginTop: "10px" }}
            onClick={() => deleteArrow(arrow)}
          >
            Delete
          </button>
        </div>
      </ArrowWrapper>
    </>
  );
};
